
export default superclass => class extends superclass {
    dispatch(x) {
        this.sequencerEngine.dispatch(x);
    }

    get state() {
        return this.sequencerEngine.state;
    }
}
